import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6e6910f9&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e6910f9')) {
      api.createRecord('6e6910f9', component.options)
    } else {
      api.reload('6e6910f9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6e6910f9&", function () {
      api.rerender('6e6910f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers/users/index.vue"
export default component.exports